export default __webpack_public_path__ + "static/media/professionalSportsLeagues.6c5b260b.jpg";